export const REQUEST_LETTER_STATUSES = {
  DRAFT: 100,
  PENDING: 200,
  REJECT: 300,
  ACCEPT: 400,
}

export const getRequestLetterStatus = status => ({
  [REQUEST_LETTER_STATUSES.DRAFT]: {
    name: { uz: 'Qoralama', ru: 'Черновик', en: 'Draft' },
    variant: 'secondary',
  },
  [REQUEST_LETTER_STATUSES.PENDING]: {
    name: { uz: 'Kutilmoqda', ru: 'На рассмотрении', en: 'Pending' },
    variant: 'warning',
  },
  [REQUEST_LETTER_STATUSES.REJECT]: {
    name: { uz: 'Rad etildi', ru: 'Отклонено', en: 'Rejected' },
    variant: 'danger',
  },
  [REQUEST_LETTER_STATUSES.ACCEPT]: {
    name: { uz: 'Qabul qilindi', ru: 'Принято', en: 'Accepted' },
    variant: 'success',
  },
}[status] || {
  name: { uz: '-', ru: '-', en: '-' },
  variant: 'secondary',
})

export default function config() {
  const tableColumns = [
    { key: 'index', label: '#' },
    { key: 'title', label: 'Title', sortable: true },
    { key: 'org', label: 'Organization', sortable: true },
    { key: 'status', label: 'Status', sortable: true },
    { key: 'comment', label: 'Comment' },
    { key: 'created_at', label: 'Created At', sortable: true },
    { key: 'actions', label: 'Actions' },
  ]

  return {
    tableColumns,
  }
}
